<template>
  <app-base-main
      :hasMagin="false"
      no-padding
      parentTable
      table-border-top
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SB"></ad-campaign-select>
        <gj-select
            v-model="status"
            :options="AdKeywordEnum.SB.statusOption"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="matchType"
            :options="AdKeywordEnum.SB.matchTypeOption"
            placeholder="匹配类型"
        ></gj-select>
        <gj-select-input
            v-model="keyword"
            :options="[
              {id: 0, text: '模糊查询'},
              {id: 1, text: '精准查询'},
            ]"
        ></gj-select-input>
        <gj-date-picker
            v-model="date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSbCampaigns:update')" #right>
          <gj-tool-group
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
              :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbKeywords/export" :download-params="globalParams"
              :helpName="helpName"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSbCampaigns:update')" #operate-group>
      <gj-button type="primary" @click="addKeyword" :disabled="adStore.SB && adStore.SB.campaign && adStore.SB.campaign.updateFlag === 0">新增关键词</gj-button>
      <gj-button @click="adjustBidAddPopup" :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIsNot('state', AdKeywordEnum.SB.status.ARCHIVE)"> 应用建议竞价 </gj-button>
      <gj-button :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIsNot('state', AdKeywordEnum.SB.status.ARCHIVE)" @click="adjustBid"> 调整竞价 </gj-button>
      <gj-button :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIs('state', AdKeywordEnum.SB.status.PAUSE)" @click="enable(selectedRows)"> 启用 </gj-button>
      <gj-button :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIs('state', AdKeywordEnum.SB.status.ENABLE)" @click="pause(selectedRows)"> 暂停 </gj-button>
      <gj-button v-if="$permission('adsSbCampaigns:delete')" :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIn('state', [AdKeywordEnum.SB.status.ENABLE, AdKeywordEnum.SB.status.PAUSE])" @click="archive"> 归档</gj-button>
    </template>
    <template v-if="$permission('adsSbCampaigns:update')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbKeywords/export" :download-params="globalParams"
          setting :table-name="tableName" :table-columns="columns"
          :sort-gjtable="$refs.gjTable"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSbCampaigns:update')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          show-summary
          :summary-object="sumRecord"
          :selectable="notEqSelectable('state', AdKeywordEnum.SB.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSbCampaigns:update')">
            <gj-tag
                v-if="row.state === AdKeywordEnum.SB.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdKeywordEnum.SB.status.ENABLE"
                @input="switchStatus($event, row)"
                :disabled="row.updateFlag === 0"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdKeywordEnum.SB.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:keywordText="{row}">
          <gj-link :href="row.amazonUrl" target="_blank">{{row.keywordText | defaultShow}}</gj-link>
          <div v-if="row.localizeKeywordText">{{row.localizeKeywordText | defaultShow}}</div>
        </template>
        <template v-slot:belongGroup="{row}">
          <gj-tooltip
              :text-line="2"
              :content="row.groupName">
            {{row.groupName | defaultShow}}
          </gj-tooltip>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sb-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sb-ad-route-link>
        </template>
        <template v-slot:bid="{row}">
          {{row.bid | defaultShow(row.currencySymbol)}}
        </template>
        <!-- 建议竞价 -->
        <template v-slot:suggestBid="{ row }">
          <div class="bid-refresh" style="color: #0046f0;">
              <i class="el-icon-refresh" v-if="!row.refresh" @click="bidRefresh" style="cursor: pointer;"></i>
              <i class="el-icon-loading" v-else-if="row.refresh == 1"></i>
              <div v-else-if="row.refresh == 2">
                <div>{{ row.recommended  | defaultShow(row.currencySymbol)}}</div>
                <div style="color: #333">
                  {{ row.rangeStart | defaultShow(row.currencySymbol)}} ~ 
                  {{ row.rangeEnd | defaultShow(row.currencySymbol)}}
                </div>
              </div>
              <div style="color: #999;" v-else-if="row.refresh == 3">暂无建议</div>
          </div>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin,
    adAdvancedFilteringMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin, adKeywordTranslation
  } from "../../../common/mixin";
  import {AdKeywordEnum} from "../../../common/enum";
  import {queryMixin, selectionMixin} from "../../../../../../minxins";
  import AppAdjustBidModal from "../../../common/modal/adjust/adjust-bid-modal";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppSbAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import {isMeaningful, isMeaningless, defaultVal} from "../../../../../../utils/common";
  import {subDays} from 'date-fns';
  import {convertToDate} from "../../../../../../utils/date.util";
  import {getSbAdKeywordPage, updateSbAdKeyword, updateSpAdKeyword, adsSbBasicDataBids, getKeywordsInterpret} from "../../../../../../api/ad";
  import {adStore} from "../../../common/store";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import {LOG_OP_TYPE} from "../../../common/options";
  import AppAddSpAdKeyword from "../../common/modal/add/keyword/add-ad-keyword";

  export default {
    name: "app-sb-ad-keyword",
    components: {AppSbAdRouteLink, AdCampaignSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin,
      selectionMixin, adBaseDataMixin, initDateMixin,
      queryMixin, currencySymbolMixin, adDefaultSortMixin,
      adAdvancedFilteringMixin,adKeywordTranslation
    ],
    inject: ['getBrandAdvertisingCornerMark'],
    created() {
      this.columns = [
        adFields.status,
        adFields.keywordName,
        // adFields.servingStatus,
        {...adFields.matchType, options: AdKeywordEnum.SB.matchTypeOption},
        // adFields.effectiveness,
        // this.inCampaign ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        adFields.suggestBid,
        adFields.bid,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        adFields.acos,
        adFields.roas,
        adFields.op,
      ].filter(e => e !== null);
    },
    data() {
      return {
        helpName:'sbadmanager',
        campaignIds: [],
        adStore,
        tableData: [],
        columns: [],
        suggestedBidLoadings: [],
        AdKeywordEnum: AdKeywordEnum,
        // filter
        status: AdKeywordEnum.SB.status.ENABLE_PAUSE,
        matchType: null,
        timeStamp:null,
        keyword: {
          key: 0,
          value: null
        },
        extendSearch: null,
        date: [subDays(new Date(), 6), new Date()],
        sumRecord: {}
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    methods: {
      // 竞价刷新
      async bidRefresh() {
        this.tableData.forEach(e => {
          this.$set(e, "refresh", 1)
        });
        let params = {
          keywords: this.tableData.map(e => ({
            keywordText: e.keywordText,  matchType: e.matchType.toString()
          })),
          marketId: this.marketId
        }
        try {
          let { data } = await adsSbBasicDataBids(params)
          this.tableData.forEach(e => {
            let item = data.keywordsBidsRecoSuccessResults.find(j => j.keyword.keywordText == e.keywordText)
            if (item) {
              if (item.recommendedBid) {
                this.$set(e, "refresh", 2)
                this.$set(e, "rangeEnd", item.recommendedBid.rangeEnd)
                this.$set(e, "rangeStart", item.recommendedBid.rangeStart)
                this.$set(e, "recommended", item.recommendedBid.recommended)
              }else {
                this.$set(e, "refresh", 3)
              }
            }
          })
        } catch (error) {
          console.log(error);
        }
      },
      // 新增关键词
      addKeyword() {
        this.$gjCreate(AppAddSpAdKeyword, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          adStore,
          campaignIds: [],
          status: AdKeywordEnum.SB.status.ENABLE_PAUSE,
          type: null,
          timeStamp: this.$route.query.timeStamp,
          keyword: {
            key: 0,
            value: this.$route.query.keyword||null
          },
          extendSearch: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()]
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        this.getBrandAdvertisingCornerMark()
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            extendSearch: this.extendSearch,
            campaignIds: this.campaignIds,
            groupIds: this.groupIds,
            state: defaultVal(this.status, null),
            matchType: defaultVal(this.matchType, null),
            searchType: defaultVal(this.keyword.key, null),
            startDate: convertToDate(this.date[0]),
            endDate: convertToDate(this.date[1]),
            keywordText: this.keyword.value,
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSbAdKeywordPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, adStore.SB.currencySymbol) || [];
              this.tableData = this.tableData.map(e => ({
                ...e,
                refresh: null,
                rangeEnd: null,
                rangeStart: null,
                recommended: null,
              }))
              this.pagination = this.getPagination(data);
              this.setSuggestedBid(this.tableData);
              this.sumRecord = data.sumRecord;
              // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
              // 需从混入或者prop中获取 marketId
              if(this.tableData.length>0){
                this.getKeywordsInterpret(this.tableData)
              }

            }
          })
          .complete(() => {
            this.loading = false;
          })
      },

      setSuggestedBid(keywords) {
        const eachRequestNum = 80;
        for (let i = 0, j = eachRequestNum, k = 0; i < keywords.length; i += eachRequestNum, j += eachRequestNum, k++) {
          let subKeywords = keywords.slice(i, j);
          let params = {
            marketId: this.marketId,
            keywordsParam: {
              groupId: this.groupId,
              keywords: subKeywords.map(keyword => ({
                keyword: keyword.keywordText,
                matchType: keyword.matchType,
              }))
            }
          };
          this.suggestedBidLoadings[k] = true;
          // this.adsService.getKeywordBidRecommendations(params).pipe(
          //   finalize(() => this.suggestedBidLoadings[k] = false),
          // ).subscribe((keywordsBidRecommendations: KeywordsBidRecommendations) => {
          //   this.matchSuggestBid(subKeywords, keywordsBidRecommendations);
          // });
        }
      },
      // 设置建议竞价弹窗
      adjustBidAddPopup() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `请确认将选择的<span style="color: red;font-weight: bold;">${this.selectedRows.length}</span>个关键词竞价调整到建议竞价，更改时只对有建议竞价的对象进行操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              this.adjustBidQuick()
              modal.$gjDestroy()
            }
          }
        });
      },
      // 设置建议竞价
      adjustBidQuick() {
        for (const e of this.selectedRows) {
          if (!e.recommended) {
            this.$gjMessage.error('请先获取建议竞价')
            this.bidRefresh()
            return false
          }
        }
        this.loading = true
        let params = {
          marketId: this.marketId,
          keywords: this.selectedRows.map(e => ({
            campaignId: e.campaignId,
            keywordId: e.keywordId,
            adjustmentType: "0",
            adjustmentValue: e.recommended,
          }))
        }
        updateSbAdKeyword(params)
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
          })
          .complete(() => this.loading = false)
      },
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SB.currencySymbol,
            alertRules: [
              '选择将竞价调整：直接输入目标竞价',
              '按百分比提高/降低竞价公式：目标竞价 = 原始竞价 * ( 100 ± 输入值) / 100',
              '按固定金额提高/减低竞价公式：目标竞价 = 原始竞价 ± 输入值',
              '竞价调整四舍五入精确到小数点后两位数',
            ]
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                keywords: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  keywordId: e.keywordId,
                  adjustmentType: modal.form.bid.key,
                  adjustmentValue: modal.form.bid.value,
                }))
              }
              updateSbAdKeyword(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个关键词，确认启用？` : `确认启用关键词[${rows[0].keywordText}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                keywords: rows.map(e => ({
                  campaignId: e.campaignId,
                  keywordId: e.keywordId,
                  state: AdKeywordEnum.SB.status.ENABLE
                }))
              }
              updateSbAdKeyword(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个关键词，确认停用？` : `确认停用关键词[${rows[0].keywordText}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                keywords: rows.map(e => ({
                  campaignId: e.campaignId,
                  keywordId: e.keywordId,
                  state: AdKeywordEnum.SB.status.PAUSE
                }))
              }
              updateSbAdKeyword(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                keywords: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  keywordId: e.keywordId,
                  state: AdKeywordEnum.SB.status.ARCHIVE
                }))
              }
              updateSbAdKeyword(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            name: isMeaningful(row) ? row.keywordText : '',
            opId: isMeaningful(row) ? row.keywordId : null,
            operatingObjectTypeProps: 4,
            adType: LOG_OP_TYPE.SB,
            object: LOG_OP_TYPE.SB.KEYWORD
          }
        });
      },
    }
  }
</script>

<style scoped lang="scss">
/deep/.vxe-cell .is-align-middle{
  align-items: flex-start;
}
</style>
